import axios from "axios";
import { URLS } from "./urls";
import { createCancelableRequest } from "../_helpers/createCancelableRequest";

//Questionnaire Template Creation
export const getQuestionnaireTemplates = () => axios.get(URLS.GET_QUESTIONNAIRE_TEMPLATES);
export const getQuestionnaireTemplateDetails = (questionnaireTemplateId,versionId) => axios.get(`${URLS.GET_QUESTIONNAIRE_TEMPLATE_DETAILS}${questionnaireTemplateId}?versionId=${versionId}`);
export const createQuestionnaireTemplate = data => axios.post(URLS.CREATE_QUESTIONNAIRE_TEMPLATE, data);
export const updateQuestionnaireTemplateByKey = (questionnaireTemplateId ,data) => axios.post(URLS.UPDATE_QUESTIONNAIRE_TEMPLATE_BY_KEY + questionnaireTemplateId , data);
export const addOrUpdateQuestionnaire = (questionnaireTemplateId,data) => axios.post(URLS.ADD_OR_UPDATE_QUESTIONNAIRE + questionnaireTemplateId , data);

//Questionnaire Creation

export const getQuestionnaires = (data) => createCancelableRequest(
  axios.post,
  URLS.GET_QUESTIONNAIRES,
  data
);
export const getQuestionnaireDetails = (questionnaireId) => axios.get(URLS.GET_QUESTIONNAIRES_DETAILS + questionnaireId);
export const deleteQuestionnaireAnswerAttachment = ({ questionnaireId, attachmentId }) => axios.delete(`${URLS.DELETE_QUESTIONNAIRE_ANSWER_ATTACHMENT}${questionnaireId}/${attachmentId}`);
export const addOrUpdateQuestionnaireAnswer = (data) => axios.post(URLS.ADD_OR_UPDATE_QUESTIONNAIRE_ANSWER, data);
export const createQuestionnaire = data => axios.post(URLS.CREATE_QUESTIONNAIRE, data);
export const getAvailableQuestionnaireExecutors = () => axios.post(URLS.GET_AVAILABLE_QUESTIONNAIRE_EXECUTORS);
export const questionnaireUpdateExecutor = (loginId, questionnaireIds) => axios.post(`${URLS.QUESTIONNAIRE_UPDATE_EXECUTORS}?loginId=${loginId}`, questionnaireIds);
export const questionnaireUpdateStatus = (questionnaireId, data) => axios.post(`${URLS.QUESTIONNAIRE_UPDATE_STATUS}${questionnaireId}`, data);
export const questionnaireSendEmail = (questionnaireId, data) =>  axios.post(`${URLS.QUESTIONNAIRE_SEND_EMAIL}${questionnaireId}`, data);


  
